export function flatNodes<T extends { children?: T[] }>(node: T | undefined): T[] {
  if (node === undefined) {
    return []
  }

  return [node, ...(node.children?.flatMap((childNode) => flatNodes(childNode)) ?? [])]
}
